<script setup>
import { toRefs } from 'vue';

import AppApiInfoNpmActions from './ApiInfoNpmActions.vue';
import AppApiInfoGQL from './ApiInfoGQL.vue';
import AppApiInfoInputSpecs from './ApiInfoInputSpecs.vue';
import AppApiInfoMcp from './ApiInfoMcp.vue';

const props = defineProps({
  selectedPage: {
    type: String,
    required: true,
    default: 'default',
  },
  query: {
    type: Object,
    required: true,
  },
  projectId: {
    type: String,
  },
  variables: {
    type: Object,
    required: false,
  },
  jsonSchema: {
    type: Object,
    required: false,
  },
  mcp: {
    type: String,
    required: false,
  },
});

const { selectedPage, query, projectId, variables, jsonSchema } = toRefs(props);
</script>

<template>
  <div class="w-full">
    <AppApiInfoGQL
      v-show="selectedPage === 'gql'"
      :code="query"
      :projectId="projectId"
      :variables="variables"
    />
    <AppApiInfoNpmActions
      v-show="selectedPage === 'npm'"
      :query="query"
      :projectId="projectId"
      :variables="variables"
    />
    <AppApiInfoInputSpecs
      v-show="selectedPage === 'input_specs'"
      :jsonSchema
      :variables="variables"
    />
    <AppApiInfoMcp
      v-show="selectedPage === 'mcp'"
      :url="`https://mcp.cognitiveactions.com/sse/${mcp}`"
    />
  </div>
</template>
